import { takeLatest, put, call, select } from 'redux-saga/effects';
import { RECORD_ONE_TIME_WORKOUT_SAGA } from "../sagaTypes";
import { loaderAction, oneTimeWorkoutFormAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { getBookingUsersSagaAction } from "../sagaActions";
import { GetWorkoutsThunk } from "../thunks/GetWorkoutsThunk";
import { ONE_TIME_WORKOUT_FORM_INITIAL } from "../initialStateConstant";

const request = data => {
    return fetch(`${ url }/record_one_time_workout`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerRecordOneTimeWorkout(args) {
    const user = yield select(state => state.user);
    const currentEstablishment = yield select(state => state.currentEstablishment);
    const booking_users_form = yield select(state => state.booking_users_form);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);
        formData.append('establishment', currentEstablishment);
        formData.append('user', args.data.user);
        formData.append('type', args.data.type);
        formData.append('coach', args.data.coach);
        formData.append('payment', args.data.payment);
        formData.append('discount', args.data.discount);
        formData.append('custom_date', args.data.date || '');
        formData.append('custom_time', args.data.time || '');

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Закрываем форму разового посещения
            yield put(oneTimeWorkoutFormAction(ONE_TIME_WORKOUT_FORM_INITIAL));

            // Если добавляли абонемент через список записанных на групповое занятие пользователей
            if (booking_users_form.open && booking_users_form.id) {
                // Обновляем список пользователей
                yield put(getBookingUsersSagaAction({ booking_id: booking_users_form.id }));
            }
            else {
                // Обновляем список тренировок
                yield put(GetWorkoutsThunk({ page: 1 }));
            }
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherRecordOneTimeWorkout() {
    yield takeLatest(RECORD_ONE_TIME_WORKOUT_SAGA, workerRecordOneTimeWorkout);
}